/** A single description for feature roles on the company level. */

/**
 * Object that determines all different features for users to get
 * access on the company level.
 */

/**
 * Signature for the function hasUserValidFeatureCompanyLevel.
 */

/** Names for all features within the company level. */
export let RequiredFeatureCompanyLevelName = /*#__PURE__*/function (RequiredFeatureCompanyLevelName) {
  /** Whether the user can see projects of the company related to the user. */
  RequiredFeatureCompanyLevelName["canViewProjects"] = "canViewProjects";
  /** Whether the use has permission to access the groups page and view all company groups */
  RequiredFeatureCompanyLevelName["canViewCompanyGroups"] = "canViewCompanyGroups";
  /** Whether the user has permission to see the company members list */
  RequiredFeatureCompanyLevelName["canViewCompanyMembers"] = "canViewCompanyMembers";
  /** Whether the user has permission to see the company analytics page */
  RequiredFeatureCompanyLevelName["canViewAnalytics"] = "canViewAnalytics";
  /** Whether the user has permission to see the company premium analytics pages */
  RequiredFeatureCompanyLevelName["canViewPremiumAnalytics"] = "canViewPremiumAnalytics";
  /** Whether the user has permission to see the company integrations page */
  RequiredFeatureCompanyLevelName["canViewIntegrations"] = "canViewIntegrations";
  /** Whether the user has permission to see the company settings page */
  RequiredFeatureCompanyLevelName["canViewWorkspaceSettings"] = "canViewWorkspaceSettings";
  /** Whether the user has permission to create new projects */
  RequiredFeatureCompanyLevelName["canCreateProjects"] = "canCreateProjects";
  /** Whether the user has permission to export the workspace data */
  RequiredFeatureCompanyLevelName["canExportWorkspace"] = "canExportWorkspace";
  /** Whether the user has permission to use the teams feature */
  RequiredFeatureCompanyLevelName["canUseTeams"] = "canUseTeams";
  /**
   * Whether project members can be assigned a role other than viewer. Plans below
   * "Scan Professional" only allow inviting viewers to a project.
   */
  RequiredFeatureCompanyLevelName["canAssignProjectRoles"] = "canAssignProjectRoles";
  /**
   * Whether the workspace can assign managers. When disabled the workspace has a single
   * admin, so the project manager selection is hidden and the admin is used implicitly.
   */
  RequiredFeatureCompanyLevelName["canAssignManagers"] = "canAssignManagers";
  /** Whether the workspace has the feature hb-to-sxg-migrated enabled */
  RequiredFeatureCompanyLevelName["isHbToSxgMigrated"] = "isHbToSxgMigrated";
  return RequiredFeatureCompanyLevelName;
}({});